import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ShareDataProvider } from "./contexts/ShareDataContext";
import { NotificationsProvider } from "./contexts/NotificationsContext";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ProjectList from "./pages/ProjectList";
import ProjectDetail from "./pages/ProjectDetail";
import "./App.css";
import WebNotificationManager from "./components/WebNotificationManager";
import ErrorBoundary from "./components/ErrorBoundary";
import PWAInstallButton from "./components/PWAInstallButton";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading-container">Loading...</div>;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const shareToken = urlParams.get("share_token");

  return user || shareToken ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading-container">Loading...</div>;
  }

  return user ? <Navigate to="/projects" /> : children;
}

function App() {
  return (
    <ErrorBoundary fallbackType="page">
      <Router>
        <ErrorBoundary fallbackType="page">
          <AuthProvider>
            <ShareDataProvider>
              <NotificationsProvider>
                <div className="app">
                  <ErrorBoundary fallbackType="inline">
                    <WebNotificationManager />
                  </ErrorBoundary>
                  <ErrorBoundary fallbackType="inline">
                    <PWAInstallButton />
                  </ErrorBoundary>
                  <Routes>
                    <Route
                      path="/login"
                      element={
                        <ErrorBoundary fallbackType="page">
                          <PublicRoute>
                            <Login />
                          </PublicRoute>
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/signup"
                      element={
                        <ErrorBoundary fallbackType="page">
                          <PublicRoute>
                            <Signup />
                          </PublicRoute>
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/projects"
                      element={
                        <ErrorBoundary fallbackType="page">
                          <PrivateRoute>
                            <ProjectList />
                          </PrivateRoute>
                        </ErrorBoundary>
                      }
                    />
                    <Route
                      path="/projects/:projectId"
                      element={
                        <ErrorBoundary fallbackType="page">
                          <PrivateRoute>
                            <ProjectDetail />
                          </PrivateRoute>
                        </ErrorBoundary>
                      }
                    />
                    <Route path="/" element={<Navigate to="/projects" />} />
                  </Routes>
                </div>
              </NotificationsProvider>
            </ShareDataProvider>
          </AuthProvider>
        </ErrorBoundary>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
